<form class="xr-auth-stack" [formGroup]="recovery_password_reset" (ngSubmit)="onSubmit()" #passwordResetDir="ngForm">
  <div>
    <h1 class="xr-auth-title">{{ "recovery_password.reset_title" | translate }}</h1>
    <p class="xr-auth-subtitle">{{ "recovery_password.insert_new_password_reset" | translate }}</p>
  </div>

  <section class="xr-rules" aria-labelledby="reset-rules-title">
    <h2 id="reset-rules-title" class="xr-rules-title">{{ "recovery_password.password_rules" | translate }}</h2>
    <ul>
      <li>{{ "recovery_password.rules_1" | translate }}</li>
      <li>{{ "recovery_password.rules_2" | translate }}</li>
      <li>{{ "recovery_password.rules_3" | translate }}</li>
      <li>{{ "recovery_password.rules_4" | translate }}</li>
    </ul>
  </section>

  <div class="xr-auth-field">
    <label class="xr-auth-label" for="new-password1">{{ "recovery_password.new_password" | translate }}</label>
    <mat-form-field appearance="outline" color="primary" class="hide-hint">
      <input matInput id="new-password1" [type]="hideNewPassword ? 'password' : 'text'" formControlName="new_password1"
             autocomplete="new-password"/>
      <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideNewPassword = !hideNewPassword"
              [attr.aria-label]="(hideNewPassword ? 'login.show_password' : 'login.hide_password') | translate"
              [attr.aria-pressed]="!hideNewPassword">
        <i-tabler [name]="hideNewPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
      </button>
    </mat-form-field>
    <mat-error class="xr-auth-error" *ngIf="password1FormControl?.hasError('required') && (password1FormControl?.touched || passwordResetDir.submitted)">
      {{ 'login.password_required' | translate }}
    </mat-error>
    <mat-error class="xr-auth-error" *ngIf="password1FormControl?.hasError('minlength') && (password1FormControl?.touched || passwordResetDir.submitted)">
      {{ 'recovery_password.password_min_length' | translate: { minLength: passwordMinLength } }}
    </mat-error>
    <mat-error class="xr-auth-error" *ngIf="password1FormControl?.hasError('passwordStrength') && (password1FormControl?.touched || passwordResetDir.submitted)">
      {{ 'recovery_password.password_strength_error' | translate }}
    </mat-error>
  </div>

  <div class="xr-auth-field">
    <label class="xr-auth-label" for="new-password2">{{ "recovery_password.confirm_password" | translate }}</label>
    <mat-form-field appearance="outline" color="primary" class="hide-hint">
      <input matInput id="new-password2" [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="new_password2"
             autocomplete="new-password"/>
      <button mat-icon-button matSuffix type="button" class="password-toggle" (click)="hideConfirmPassword = !hideConfirmPassword"
              [attr.aria-label]="(hideConfirmPassword ? 'login.show_password' : 'login.hide_password') | translate"
              [attr.aria-pressed]="!hideConfirmPassword">
        <i-tabler [name]="hideConfirmPassword ? 'eye' : 'eye-off'" class="icon-18"></i-tabler>
      </button>
    </mat-form-field>
    <mat-error class="xr-auth-error" *ngIf="password2FormControl?.hasError('required') && (password2FormControl?.touched || passwordResetDir.submitted)">
      {{ 'login.password_required' | translate }}
    </mat-error>
    <mat-error class="xr-auth-error" *ngIf="recovery_password_reset.hasError('passwordMismatch') && (recovery_password_reset.touched || passwordResetDir.submitted)">
      {{ 'recovery_password.passwords_dont_match' | translate }}
    </mat-error>
  </div>

  <button type="submit" class="xr-btn xr-btn--primary xr-auth-submit" [disabled]="!recovery_password_reset.valid">
    {{ 'recovery_password.save_new_password' | translate }}
  </button>
  <button type="button" class="xr-auth-link" (click)="goBack()">
    <span aria-hidden="true">←&nbsp;</span>{{ 'recovery_password.back_recovery_password' | translate }}
  </button>
</form>
